import Body from "./Body";
import UpdatePrice from "./UpdatePrice";

export const Components = {
  Body,
  UpdatePrice,
};
